import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import { Portal } from 'radix-ui';
const createPortalContainer = () => {
  const id = 'toast-portal';
  let el = document.getElementById(id);
  if (!el) {
    el = document.createElement('div');
    el.id = id;
    el.setAttribute('aria-live', 'polite');
    document.body.appendChild(el);
  }
  return el;
};

/**
 * Finds or creates the shared `#toast-portal` container (`aria-live="polite"`) on `document.body`.
 * The container is removed when this component unmounts.
 */
export const ToastPortal = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const [portalContainer] = useState(createPortalContainer);
  let t1;
  let t2;
  if ($[0] !== portalContainer) {
    t1 = () => {
      if (!portalContainer.isConnected) {
        document.body.appendChild(portalContainer);
      }
      return () => {
        portalContainer.remove();
      };
    };
    t2 = [portalContainer];
    $[0] = portalContainer;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== children || $[4] !== portalContainer) {
    t3 = <Portal.Root container={portalContainer}>{children}</Portal.Root>;
    $[3] = children;
    $[4] = portalContainer;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};